(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3649],{

/***/ 99793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_icons_ChevronLeftIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88774);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var BackLinkContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
  componentId: "sc-v4asvy-0"
})(["display:flex;align-items:flex-start;padding:0.5rem 0;"]);
var BackLink = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].a.withConfig({
  componentId: "sc-v4asvy-1"
})(["display:flex;font-size:0.75rem;color:#1454b8;align-items:center;padding:0.25rem 0;text-decoration:none;"]);
var BackIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_components_icons_ChevronLeftIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
  componentId: "sc-v4asvy-2"
})(["margin-right:0.5rem;"]);

var RecipeHomeBackLink = function RecipeHomeBackLink() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(BackLinkContainer, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      passHref: true,
      href: '/recipes',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(BackLink, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(BackIcon, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          children: "Back to recipes"
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RecipeHomeBackLink);

/***/ }),

/***/ 80617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19521);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(246);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RecipeCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96064);
/* harmony import */ var _EventTrackingProvider_EventTrackingProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87661);
/* harmony import */ var _lib_trackClicksAndImpressions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8183);
/* harmony import */ var _CheckoutAddressProvider_CheckoutAddressProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1029);
/* harmony import */ var _lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80732);
/* harmony import */ var _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31035);
/* harmony import */ var _Loader_Loader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90714);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);














var List = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].ul.withConfig({
  componentId: "sc-pe51j1-0"
})(["display:flex;flex-wrap:wrap;"]);
var Header = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
  componentId: "sc-pe51j1-1"
})([""]);
var HeaderTitle = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
  componentId: "sc-pe51j1-2"
})(["font-size:1.125rem;line-height:1.75rem;font-weight:bold;"]);
var ResultDescription = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
  componentId: "sc-pe51j1-3"
})(["font-size:0.75rem;color:#696969;font-weight:bold;line-height:1rem;margin-bottom:1rem;"]);
var LoaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
  componentId: "sc-pe51j1-4"
})(["display:flex;justify-content:center;align-items:center;padding:1.5rem 0;"]);

var RecipeList = function RecipeList(_ref) {
  var items = _ref.items,
      headerTitle = _ref.headerTitle,
      headerDescription = _ref.headerDescription,
      loadMore = _ref.loadMore,
      hasMore = _ref.hasMore,
      track = _ref.track,
      label = _ref.label,
      pageType = _ref.pageType,
      checkoutAddress = _ref.checkoutAddress,
      trackSplit = _ref.trackSplit,
      ctaLocationMeta = _ref.ctaLocationMeta;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      trackedBanners = _useState[0],
      setTrackedBanners = _useState[1];

  var mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var trackBannerImpressions = function trackBannerImpressions() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      action: '',
      prevStoreId: '',
      prevDBPStoreId: '',
      asset_type: 'Lifestyle',
      page_type: 'Recipe Listing'
    };
    var storeIdToTrack = params.prevStoreId || (0,_lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .getNCheckFn */ .Am)(checkoutAddress, 'clientId', '').toString();
    var dbpStoreIdToTrack = params.prevDBPStoreId || (0,_lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .getNCheckFn */ .Am)(checkoutAddress, 'storeId', '').toString();
    (0,_lib_trackClicksAndImpressions__WEBPACK_IMPORTED_MODULE_4__/* .trackPromoImpressions */ ._)({
      track: track,
      trackSplit: trackSplit,
      storeIdToTrack: storeIdToTrack,
      dbpStoreIdToTrack: dbpStoreIdToTrack,
      banners: [],
      currentType: _lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .impressionTypes.RECIPE_IMPRESSION */ .ob.RECIPE_IMPRESSION,
      params: params
    });

    if (params.action === 'trackOnUpdate' && !trackedBanners) {
      setTrackedBanners(true);
    }
  };

  var createObserver = function createObserver(_ref2) {
    var elementRef = _ref2.elementRef,
        bannerTrackObj = _ref2.bannerTrackObj,
        callAction = _ref2.callAction;

    if (callAction === 'onLoad' || callAction === 'afterUpdate' && trackedBanners) {
      (0,_lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .createNewObserver */ .Qj)({
        productRef: elementRef.current,
        trackType: _lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .trackingTypes.TRACK_ONCE */ .m4.TRACK_ONCE,
        productTrackingData: bannerTrackObj,
        splitTrackingData: Object.assign({}, bannerTrackObj, (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
          event_type: _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .SPLIT_EVENT */ .iJ
        }, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .GTM_ENV_VAR.EVENT */ .Zr.EVENT, 'splitPromoImpression')),
        options: {
          root: null,
          rootMargin: '0px',
          threshold: 0.01
        },
        impressionType: _lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .impressionTypes.RECIPE_IMPRESSION */ .ob.RECIPE_IMPRESSION,
        splitImpressionType: _lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .impressionTypes.SPLIT_RECIPE_IMPRESSION */ .ob.SPLIT_RECIPE_IMPRESSION
      });

      if (trackedBanners) {
        setTrackedBanners(false);
      }
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    _lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .triggerImpressionsTracking.subscribe */ .zJ.subscribe(_lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .impressionTypes.RECIPE_IMPRESSION */ .ob.RECIPE_IMPRESSION, function (data) {
      if (data === _lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .impressionTypes.RECIPE_IMPRESSION */ .ob.RECIPE_IMPRESSION) {
        trackBannerImpressions();
      }
    });
    return function () {
      _lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .triggerImpressionsTracking.unsubscribe */ .zJ.unsubscribe(_lib_impressionsTracker__WEBPACK_IMPORTED_MODULE_6__/* .impressionTypes.RECIPE_IMPRESSION */ .ob.RECIPE_IMPRESSION);
      trackBannerImpressions({
        forceTrack: true,
        action: 'abandon'
      });
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      trackBannerImpressions({
        action: 'trackOnUpdate',
        prevStoreId: (0,_lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .getNCheckFn */ .Am)(checkoutAddress, 'clientId', '').toString(),
        prevDBPStoreId: (0,_lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_7__/* .getNCheckFn */ .Am)(checkoutAddress, 'storeId', '').toString()
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [checkoutAddress.storeId]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(Header, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(HeaderTitle, {
        children: headerTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(ResultDescription, {
        children: headerDescription
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((react_infinite_scroller__WEBPACK_IMPORTED_MODULE_1___default()), {
      pageStart: 0,
      loadMore: loadMore,
      hasMore: hasMore,
      loader: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(LoaderContainer, {
        id: "recipe-list-loader",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_Loader_Loader__WEBPACK_IMPORTED_MODULE_8__["default"], {})
      }),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(List, {
        children: items.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_RecipeCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            item: item,
            pageType: pageType,
            bannerPosition: index + 1,
            trackBannerImpressions: trackBannerImpressions,
            label: label,
            sectionTitle: label,
            createObserverInfo: createObserver,
            ctaLocationMeta: ctaLocationMeta
          }, item.isin);
        })
      })
    })]
  });
};

var RecipeListWrp = function RecipeListWrp(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_CheckoutAddressProvider_CheckoutAddressProvider__WEBPACK_IMPORTED_MODULE_5__.CheckoutAddressConsumer, {
    children: function children(_ref3) {
      var checkoutAddress = _ref3.checkoutAddress;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_EventTrackingProvider_EventTrackingProvider__WEBPACK_IMPORTED_MODULE_3__/* .EventTrackingConsumer */ .fI, {
        children: function children(_ref4) {
          var track = _ref4.track,
              trackSplit = _ref4.trackSplit;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(RecipeList, Object.assign({}, props, {
            track: track,
            trackSplit: trackSplit,
            checkoutAddress: checkoutAddress
          }));
        }
      });
    }
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RecipeListWrp);

/***/ }),

/***/ 88774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function SvgChevronLeft(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", Object.assign({
    width: 5,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.61 4L4.47 6.862a.667.667 0 11-.942.943L.195 4.47a.667.667 0 010-.942L3.53.195a.667.667 0 11.942.943L1.61 4z",
      fill: "#1557BF"
    })
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronLeft);

/***/ }),

/***/ 39364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(90116);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(59499);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(50029);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64687);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45996);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(19521);
/* harmony import */ var _lib_Media__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9505);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _lib_fetch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47786);
/* harmony import */ var _ntuctech_devex_tangram_Theme_NdsThemeProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54285);
/* harmony import */ var _ntuctech_devex_tangram_Theme_NdsThemeProvider__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ntuctech_devex_tangram_Theme_NdsThemeProvider__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Recipe_RecipeSearchBanner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86643);
/* harmony import */ var _components_Recipe_RecipeList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80617);
/* harmony import */ var _components_EventTrackingProvider_EventTrackingProvider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87661);
/* harmony import */ var _components_Recipe_recipeUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62498);
/* harmony import */ var _components_Recipe_RecipeErrorPage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1336);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31035);
/* harmony import */ var _components_Recipe_RecipeLayout__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34987);
/* harmony import */ var _components_Recipe_RecipeHomeBackLink__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99793);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57756);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(85893);




















var RecipeErrorPage = next_dynamic__WEBPACK_IMPORTED_MODULE_13___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1336));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1336)];
    }
  }
});





var RECIPE_SEARCH_LAYOUT_NAME = 'RecipeSearch';
var PAGE_SIZE = 20;
var MainContainer = styled_components__WEBPACK_IMPORTED_MODULE_19__["default"].div.withConfig({
  componentId: "sc-122wuff-0"
})(["", "{padding:0 1.5rem;}", "{padding:0 1rem;}"], (0,_components_Recipe_RecipeLayout__WEBPACK_IMPORTED_MODULE_15__/* .below */ .B2)(_components_Recipe_RecipeLayout__WEBPACK_IMPORTED_MODULE_15__/* .recipeBreakpoints.max */ .B5.max), _lib_Media__WEBPACK_IMPORTED_MODULE_4__/* .SCREEN_SIZE.Below.MobileL */ .yJ.Below.MobileL);

var getSearchResult = function getSearchResult(data) {
  var _data$page;

  var layouts = (data === null || data === void 0 ? void 0 : (_data$page = data.page) === null || _data$page === void 0 ? void 0 : _data$page.layouts) || [];
  var recipeSearch = layouts.find(function (layout) {
    return layout.name === RECIPE_SEARCH_LAYOUT_NAME;
  });
  return recipeSearch === null || recipeSearch === void 0 ? void 0 : recipeSearch.value;
};

var fetchRecipeSearchResults = /*#__PURE__*/function () {
  var _ref = (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(query) {
    var page,
        basePath,
        path,
        response,
        _args = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;

            if (query) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {});

          case 3:
            _context.prev = 3;
            basePath = "layout/recipe/search";
            path = "".concat(basePath, "?size=").concat(PAGE_SIZE, "&q=").concat(query, "&page=").concat(page);
            _context.next = 8;
            return (0,_lib_fetch__WEBPACK_IMPORTED_MODULE_6__.get)(path);

          case 8:
            response = _context.sent;

            if (!(response !== null && response !== void 0 && response.data)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", {
              recipeSearch: response.data,
              statusCode: response.code
            });

          case 11:
            return _context.abrupt("return", {
              statusCode: response.code
            });

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", {
              statusCode: 500
            });

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 14]]);
  }));

  return function fetchRecipeSearchResults(_x) {
    return _ref.apply(this, arguments);
  };
}();

var RecipeSearchWrp = function RecipeSearchWrp(props) {
  var _router$query5, _router$query6;

  var router = props.router,
      recipeSearchData = props.recipeSearch,
      statusCode = props.statusCode,
      track = props.track;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(router.query.q),
      searchTerm = _useState[0],
      setSearchTerm = _useState[1];

  var recipeSearch = getSearchResult(recipeSearchData);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(recipeSearch),
      searchResult = _useState2[0],
      setSearchResult = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setSearchTerm(router.query.q);
  }, [router.query.q]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setSearchResult(recipeSearch);
  }, [recipeSearch]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _router$query;

    if ((_router$query = router.query) !== null && _router$query !== void 0 && _router$query.q && !searchResult) {
      return;
    }

    if (!searchResult || searchResult.total === 0) {
      var _router$query2, _createRecipeSearchEv;

      var event = (0,_components_Recipe_recipeUtils__WEBPACK_IMPORTED_MODULE_11__/* .createRecipeSearchEvent */ .sU)((_createRecipeSearchEv = {}, (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_createRecipeSearchEv, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.EVENT_ACTION */ .Zr.EVENT_ACTION, _components_Recipe_recipeUtils__WEBPACK_IMPORTED_MODULE_11__/* .RECIPE_SEARCH_EVENT_ACTION.SEARCH_NO_RESULTS */ .R$.SEARCH_NO_RESULTS), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_createRecipeSearchEv, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.PAGE_TYPE */ .Zr.PAGE_TYPE, 'Recipe Zero Search Result'), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_createRecipeSearchEv, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.SEARCH_TERM */ .Zr.SEARCH_TERM, ((_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.q) || ''), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_createRecipeSearchEv, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.SEARCH_RES_COUNT */ .Zr.SEARCH_RES_COUNT, 0), _createRecipeSearchEv));
      track(event);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [searchResult]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _router$query3;

    (0,_lib_utils__WEBPACK_IMPORTED_MODULE_17__/* .setCtaLocationMeta */ .A4)([((_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.q) || '']);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _router$query4, _track;

    var searchKeywords = (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.q;
    track((_track = {}, (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.PAGE_TYPE */ .Zr.PAGE_TYPE, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .PAGE_TYPES.RECIPE_SEARCH */ .sL.RECIPE_SEARCH), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.SCREEN_NAME */ .Zr.SCREEN_NAME, "lifestyle | search".concat(searchKeywords ? " | ".concat(searchKeywords) : '')), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.EVENT_CAT */ .Zr.EVENT_CAT, 'recipe'), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.EVENT_ACTION */ .Zr.EVENT_ACTION, 'landed'), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.EVENT_LABEL */ .Zr.EVENT_LABEL, "".concat(_lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .PAGE_TYPES.RECIPE_SEARCH */ .sL.RECIPE_SEARCH).concat(searchKeywords ? " - ".concat(searchKeywords) : '')), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_track, _lib_eventTrackerFunction__WEBPACK_IMPORTED_MODULE_14__/* .GTM_ENV_VAR.ASSET_TYPE */ .Zr.ASSET_TYPE, 'Lifestyle'), _track));
  });

  if ((_router$query5 = router.query) !== null && _router$query5 !== void 0 && _router$query5.q && !searchResult) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(RecipeErrorPage, {
      categoryList: props.categoryList,
      organizationData: props.organizationData,
      errorCode: statusCode,
      pathname: router === null || router === void 0 ? void 0 : router.pathname
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)("title", {
        children: ["Recipes", router.query.q ? " - ".concat(router.query.q) : '']
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("link", {
        rel: "dns-prefetch",
        href: "https://www.innit.com/"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("link", {
        rel: "preconnect",
        href: "https://www.innit.com/"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("meta", {
        property: "og:title",
        content: "Recipes | ".concat(router.query.q)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("meta", {
        name: "description",
        content: "Create the perfect home-cooked meal with our wide library of easy cooking tips, meal ideas and food inspiration from FairPrice"
      }, "meta_description"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("meta", {
        property: "og:site_name",
        content: "FairPrice"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)((_ntuctech_devex_tangram_Theme_NdsThemeProvider__WEBPACK_IMPORTED_MODULE_7___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        categoryList: props.categoryList,
        organizationData: props.organizationData,
        noWrapper: "noGap",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_components_Recipe_RecipeLayout__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_components_Recipe_RecipeSearchBanner__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            searchTerm: searchTerm,
            onSearchTermChange: setSearchTerm
          }), !searchResult || searchResult.total === 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_components_Recipe_RecipeErrorPage__WEBPACK_IMPORTED_MODULE_12__.RecipeErrorBody, {
            title: "Nothing came up",
            description: "Try searching with a different keyword or go back to Home.",
            buttonText: "Back to home",
            buttonLink: "/recipes"
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(MainContainer, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_components_Recipe_RecipeHomeBackLink__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_components_Recipe_RecipeList__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
              items: searchResult.recipes,
              pageType: "Recipe Listing",
              label: "Recipe Search - ".concat(router.query.q),
              headerTitle: "Results for '".concat(router.query.q, "'"),
              headerDescription: "".concat(searchResult.total, " recipes found"),
              hasMore: searchResult.page < searchResult.total / PAGE_SIZE,
              ctaLocationMeta: [((_router$query6 = router.query) === null || _router$query6 === void 0 ? void 0 : _router$query6.q) || ''],
              loadMore: /*#__PURE__*/(0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
                var _yield$fetchRecipeSea, newRecipeSearch, newSearchResult;

                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (searchResult) {
                          _context2.next = 2;
                          break;
                        }

                        return _context2.abrupt("return");

                      case 2:
                        _context2.next = 4;
                        return fetchRecipeSearchResults(searchTerm, searchResult.page + 1);

                      case 4:
                        _yield$fetchRecipeSea = _context2.sent;
                        newRecipeSearch = _yield$fetchRecipeSea.recipeSearch;

                        if (newRecipeSearch) {
                          newSearchResult = getSearchResult(newRecipeSearch);
                          setSearchResult(Object.assign({}, newSearchResult, {
                            recipes: [].concat((0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_22__["default"])(searchResult.recipes), (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_22__["default"])(newSearchResult.recipes))
                          }));
                        }

                      case 7:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }))
            })]
          })]
        })
      })
    })]
  });
};

var RecipeSearch = function RecipeSearch(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_components_EventTrackingProvider_EventTrackingProvider__WEBPACK_IMPORTED_MODULE_10__/* .EventTrackingConsumer */ .fI, {
    children: function children(_ref3) {
      var track = _ref3.track;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(RecipeSearchWrp, Object.assign({}, props, {
        track: track
      }));
    }
  });
};

RecipeSearch.getInitialProps = /*#__PURE__*/function () {
  var _ref4 = (0,_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(ctx) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", fetchRecipeSearchResults(ctx.query.q));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x2) {
    return _ref4.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["default"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_2__.withRouter)(RecipeSearch));

/***/ }),

/***/ 24665:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipeSearch",
      function () {
        return __webpack_require__(39364);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isReverse && this.loadMore) {
        var parentElement = this.getParentElement(this.scrollComponent);
        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
        this.loadMore = false;
      }
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: 'isPassiveSupported',
    value: function isPassiveSupported() {
      var passive = false;

      var testOptions = {
        get passive() {
          passive = true;
        }
      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }
  }, {
    key: 'eventListenerOptions',
    value: function eventListenerOptions() {
      var options = this.props.useCapture;

      if (this.isPassiveSupported()) {
        options = {
          useCapture: this.props.useCapture,
          passive: true
        };
      } else {
        options = {
          passive: false
        };
      }
      return options;
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachMousewheelListener',
    value: function detachMousewheelListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'getParentElement',
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
      if (scrollParent != null) {
        return scrollParent;
      }
      return el && el.parentNode;
    }
  }, {
    key: 'filterProps',
    value: function filterProps(props) {
      return props;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!this.props.hasMore || !parentElement) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = parentElement;
      }

      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'mousewheelListener',
    value: function mousewheelListener(e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !this.isPassiveSupported()) {
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var parentNode = this.getParentElement(el);

      var offset = void 0;
      if (this.props.useWindow) {
        var doc = document.documentElement || document.body.parentNode || document.body;
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateOffset(el, scrollTop);
        }
      } else if (this.props.isReverse) {
        offset = parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
      }

      // Here we make sure the element is visible as well as checking the offset
      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
        this.detachScrollListener();
        this.beforeScrollHeight = parentNode.scrollHeight;
        this.beforeScrollTop = parentNode.scrollTop;
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
          this.loadMore = true;
        }
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(el, scrollTop) {
      if (!el) {
        return 0;
      }

      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderProps = this.filterProps(this.props);

      var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      if (hasMore) {
        if (loader) {
          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
        } else if (this.defaultLoader) {
          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
        }
      }
      return _react2.default.createElement(element, props, childrenArray);
    }
  }]);

  return InfiniteScroll;
}(_react.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports["default"] = InfiniteScroll;
module.exports = exports['default'];


/***/ }),

/***/ 246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(57761)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6012,4133,874,8893,8919,4232,1336,5722,9774,2888,179], function() { return __webpack_exec__(24665); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);